import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(4),
    textAlign: "center",
  },
}));

export const NotFound = () => {
  const classes = useStyles();
  return <Container className={classes.container}>404 Not Found.</Container>;
};
